export const shortChannels = [
  "google-search",
  "google-display",
  "snapchat",
  "ebay-kleinanzeigen",
  "snapchat",
  "tiktok",
  "youtube",
  "spotify"
];

export const darkChannels = ["instagram"];
